import React from "react"
import { sanitizeUrl } from "@braintree/sanitize-url"
import PropTypes from "prop-types"

export const HelmetGlobal = ({ location }) => {
  const canonical = getCanonical()

  function getCanonical() {
    let pathname = sanitizeUrl(location.pathname)
    if (pathname.charAt(pathname.length - 1) === "/") {
      pathname = pathname.substring(0, pathname.length - 1);
    }
    pathname += pathname.endsWith("/") ? "" : "/"

    return "https://www.fabrick.com" + pathname
  }

  return <>
    {/* <meta name="facebook-domain-verification" content="io9ht460e4dqd3vulsfdz0te2qx2na" /> */}
    {/* <meta name="facebook-domain-verification" content="duxe3j5jy3fqzz4tn99p3f7qx52g7d" /> */}

    <meta name="google-site-verification" content="FZWeNLHnq8BGvIagF5tmGmLh6tNn5MLQy20xxGmvxn8" />

    {/* <script type="application/ld+json">
      {JSON.stringify(OrganizationJson)}
    </script> */}

    <link rel="icon" type="image/svg" href="/images/favicon.png" />
    {/* <meta name="facebook-domain-verification" content="31dr9xzdgrebg9yunrnsn9h77tmy28" /> */}

    <link rel="canonical" href={canonical} />

    {/* <script dangerouslySetInnerHTML={{
      __html: `window.dataLayer = window.dataLayer || []; function gtag() { dataLayer.push(arguments); }
        gtag("consent", "default", {
          ad_personalization: "denied",
          ad_storage: "denied",
          ad_user_data: "denied",
          analytics_storage: "denied",
          functionality_storage: "denied",
          personalization_storage: "denied",
          security_storage: "granted",
          wait_for_update: 500,
        });
        // gtag("set", "ads_data_redaction", true);
        gtag("set", "url_passthrough", true);`
    }} /> */}

    <script dangerouslySetInnerHTML={{
      __html: `window.dataLayer = window.dataLayer || [];
        function gtag() {dataLayer.push(arguments);}
        gtag("consent", "default", {
          ad_personalization: "denied",
          ad_storage: "denied",
          ad_user_data: "denied",
          analytics_storage: "granted",
          functionality_storage: "denied",
          personalization_storage: "denied",
          security_storage: "granted",
          wait_for_update: 500,
        });
        // gtag("set", "ads_data_redaction", true);
        // gtag("set", "url_passthrough", true);`
    }} />


    {<script dangerouslySetInnerHTML={{
      __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://sgtm.fabrick.com/gmefaywe.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-MN3W72HK');`
    }} />}
  </>
}
HelmetGlobal.propTypes = {
  location: PropTypes.any
}

export default HelmetGlobal